// @ts-expect-error Untyped
import { getCookie as getCookieHubHttp } from 'hub-http/helpers/cookies';
export const getCookie = key => getCookieHubHttp(key, document.cookie);